export interface Article {
  id: number;
  slug: string;
  title: string;
  excerpt: string;
  category: 'core' | 'support' | 'longtail';
  categoryLabel: string;
  date: string;
  readTime: string;
  image: string;
}

export const articles: Article[] = [
  {
    id: 1,
    slug: 'joyagoo-coupon-code',
    title: 'Joyagoo Coupon Code 2026 – Get Up to 50% Off Your Order',
    excerpt: 'Find the latest working joyagoo coupon codes for 2026. Save big on shoes, hoodies, jerseys and more with exclusive promo codes updated daily.',
    category: 'core',
    categoryLabel: 'Coupon Code',
    date: 'April 10, 2026',
    readTime: '8 min read',
    image: 'https://public.readdy.ai/ai/img_res/a50c5277bdcf39b192cd4bd93655b76a.jpg',
  },
  {
    id: 2,
    slug: 'joyagoo-promo-code',
    title: 'Joyagoo Promo Code – Exclusive Deals & Discounts for 2026',
    excerpt: 'Unlock the best joyagoo promo codes and save on every purchase. From free shipping to percentage discounts, we have all the latest deals.',
    category: 'core',
    categoryLabel: 'Promo Code',
    date: 'April 9, 2026',
    readTime: '7 min read',
    image: 'https://readdy.ai/api/search-image?query=promo%20code%20discount%20tag%20shopping%20online%20fashion%20store%20bright%20clean%20white%20background%20modern%20minimal&width=800&height=500&seq=art002&orientation=landscape',
  },
  {
    id: 3,
    slug: 'joyagoo-review',
    title: 'Joyagoo Review 2026 – Is It Legit? Honest Buyer\'s Guide',
    excerpt: 'Read our comprehensive joyagoo review covering product quality, shipping times, customer service, and whether joyagoo is worth your money.',
    category: 'support',
    categoryLabel: 'Review',
    date: 'April 8, 2026',
    readTime: '6 min read',
    image: 'https://readdy.ai/api/search-image?query=product%20review%20rating%20stars%20fashion%20clothing%20quality%20check%20bright%20white%20background%20clean%20minimal%20modern&width=800&height=500&seq=art003&orientation=landscape',
  },
  {
    id: 4,
    slug: 'joyagoo-shipping',
    title: 'Joyagoo Shipping Guide – Delivery Times, Costs & Tracking',
    excerpt: 'Everything you need to know about joyagoo shipping: how long it takes, shipping costs to USA/UK/EU, and how to track your order.',
    category: 'support',
    categoryLabel: 'Shipping',
    date: 'April 7, 2026',
    readTime: '5 min read',
    image: 'https://readdy.ai/api/search-image?query=shipping%20delivery%20package%20box%20logistics%20bright%20white%20background%20clean%20minimal%20modern%20courier&width=800&height=500&seq=art004&orientation=landscape',
  },
  {
    id: 5,
    slug: 'joyagoo-legit',
    title: 'Is Joyagoo Legit? Everything You Need to Know Before Buying',
    excerpt: 'Wondering if joyagoo is legit? We break down the facts about joyagoo\'s reputation, product authenticity, buyer protection, and real customer experiences.',
    category: 'support',
    categoryLabel: 'Guide',
    date: 'April 6, 2026',
    readTime: '6 min read',
    image: 'https://readdy.ai/api/search-image?query=trust%20verified%20checkmark%20online%20shopping%20security%20bright%20white%20background%20clean%20minimal%20modern%20safe&width=800&height=500&seq=art005&orientation=landscape',
  },
  {
    id: 6,
    slug: 'how-to-use-joyagoo',
    title: 'How to Use Joyagoo – Step-by-Step Beginner\'s Guide',
    excerpt: 'New to joyagoo? This step-by-step guide walks you through how to use joyagoo, from browsing products to applying coupon codes and completing checkout.',
    category: 'support',
    categoryLabel: 'Tutorial',
    date: 'April 5, 2026',
    readTime: '5 min read',
    image: 'https://readdy.ai/api/search-image?query=step%20by%20step%20tutorial%20guide%20online%20shopping%20laptop%20phone%20bright%20white%20background%20clean%20minimal%20modern&width=800&height=500&seq=art006&orientation=landscape',
  },
  {
    id: 7,
    slug: 'joyagoo-spreadsheet',
    title: 'Joyagoo Spreadsheet – The Ultimate Product Finder Tool',
    excerpt: 'Learn how to use the joyagoo spreadsheet to find the best products, compare prices, and discover hidden deals across all categories.',
    category: 'support',
    categoryLabel: 'Spreadsheet',
    date: 'April 4, 2026',
    readTime: '5 min read',
    image: 'https://readdy.ai/api/search-image?query=spreadsheet%20data%20table%20product%20list%20fashion%20items%20bright%20white%20background%20clean%20minimal%20modern%20organized&width=800&height=500&seq=art007&orientation=landscape',
  },
  {
    id: 8,
    slug: 'joyagoo-coupon-april-2026',
    title: 'Joyagoo Coupon April 2026 – Fresh Codes Updated This Month',
    excerpt: 'Get the freshest joyagoo coupon codes for April 2026. All codes are verified and working. Save on shoes, jerseys, hoodies and more this month.',
    category: 'longtail',
    categoryLabel: 'Monthly Deal',
    date: 'April 1, 2026',
    readTime: '4 min read',
    image: 'https://readdy.ai/api/search-image?query=april%20spring%20sale%20discount%20coupon%20fashion%20clothing%20bright%20white%20background%20clean%20minimal%20modern%20seasonal&width=800&height=500&seq=art008&orientation=landscape',
  },
  {
    id: 9,
    slug: 'joyagoo-discount-new-users',
    title: 'Joyagoo Discount for New Users – First Order Savings Guide',
    excerpt: 'First time shopping on joyagoo? Discover exclusive new user discounts, welcome coupons, and how to maximize your savings on your very first order.',
    category: 'longtail',
    categoryLabel: 'New User',
    date: 'March 30, 2026',
    readTime: '4 min read',
    image: 'https://readdy.ai/api/search-image?query=new%20user%20welcome%20discount%20first%20order%20gift%20bright%20white%20background%20clean%20minimal%20modern%20celebration&width=800&height=500&seq=art009&orientation=landscape',
  },
  {
    id: 10,
    slug: 'joyagoo-shipping-to-usa',
    title: 'Joyagoo Shipping to USA – Delivery Time & Cost Breakdown',
    excerpt: 'How long does joyagoo shipping to USA take? Get the full breakdown of shipping methods, estimated delivery times, costs, and customs information.',
    category: 'longtail',
    categoryLabel: 'USA Shipping',
    date: 'March 28, 2026',
    readTime: '4 min read',
    image: 'https://readdy.ai/api/search-image?query=usa%20shipping%20delivery%20map%20package%20america%20bright%20white%20background%20clean%20minimal%20modern%20logistics&width=800&height=500&seq=art010&orientation=landscape',
  },
  {
    id: 11,
    slug: 'joyagoo-spreadsheet-2026',
    title: 'Best Joyagoo Spreadsheet 2026 – Updated Links & How to Use',
    excerpt: 'The most up-to-date joyagoo spreadsheet 2026 guide. Find working spreadsheet links, learn how to navigate them, and discover the best deals.',
    category: 'longtail',
    categoryLabel: 'Spreadsheet',
    date: 'March 25, 2026',
    readTime: '5 min read',
    image: 'https://readdy.ai/api/search-image?query=2026%20spreadsheet%20product%20catalog%20fashion%20items%20list%20bright%20white%20background%20clean%20minimal%20modern%20organized&width=800&height=500&seq=art011&orientation=landscape',
  },
  {
    id: 12,
    slug: 'best-joyagoo-spreadsheet',
    title: 'Best Joyagoo Spreadsheet – Top Picks for Smart Shoppers',
    excerpt: 'Discover the best joyagoo spreadsheet resources curated by experienced buyers. Find top-rated products, verified sellers, and exclusive deals.',
    category: 'longtail',
    categoryLabel: 'Best Picks',
    date: 'March 22, 2026',
    readTime: '5 min read',
    image: 'https://readdy.ai/api/search-image?query=best%20picks%20top%20rated%20products%20fashion%20clothing%20bright%20white%20background%20clean%20minimal%20modern%20curated&width=800&height=500&seq=art012&orientation=landscape',
  },
  {
    id: 13,
    slug: 'joyagoo-haul',
    title: 'Joyagoo Haul 2026 – Real Unboxing & Quality Review',
    excerpt: 'See real joyagoo haul photos and honest quality reviews. We ordered shoes, hoodies, and jerseys to give you an authentic look at what you\'ll receive.',
    category: 'longtail',
    categoryLabel: 'Haul',
    date: 'March 20, 2026',
    readTime: '6 min read',
    image: 'https://readdy.ai/api/search-image?query=unboxing%20haul%20fashion%20clothing%20shoes%20hoodies%20bright%20white%20background%20clean%20minimal%20modern%20review&width=800&height=500&seq=art013&orientation=landscape',
  },
  {
    id: 14,
    slug: 'joyagoo-qc-finder',
    title: 'Joyagoo QC Finder – How to Check Product Quality Before Buying',
    excerpt: 'Use the joyagoo QC finder to check product quality photos before your order ships. Learn how QC works and what to look for in quality control images.',
    category: 'longtail',
    categoryLabel: 'QC Guide',
    date: 'March 18, 2026',
    readTime: '5 min read',
    image: 'https://readdy.ai/api/search-image?query=quality%20control%20inspection%20product%20check%20magnify%20bright%20white%20background%20clean%20minimal%20modern%20detail&width=800&height=500&seq=art014&orientation=landscape',
  },
  {
    id: 15,
    slug: 'joyagoo-sheets',
    title: 'Joyagoo Sheets – Complete Guide to Finding Products & Deals',
    excerpt: 'Master joyagoo sheets with our complete guide. Learn how to search, filter, and find the best products across all categories using joyagoo sheets.',
    category: 'longtail',
    categoryLabel: 'Sheets Guide',
    date: 'March 15, 2026',
    readTime: '4 min read',
    image: 'https://readdy.ai/api/search-image?query=google%20sheets%20product%20finder%20fashion%20catalog%20bright%20white%20background%20clean%20minimal%20modern%20organized%20list&width=800&height=500&seq=art015&orientation=landscape',
  },
  {
    id: 16,
    slug: 'joyagoo-shoes-coupon',
    title: 'Joyagoo Shoes Coupon – Best Deals on Sneakers & Footwear',
    excerpt: 'Find the best joyagoo shoes coupon codes for 2026. Save on sneakers, boots, and all footwear categories with our verified discount codes.',
    category: 'longtail',
    categoryLabel: 'Shoes Deal',
    date: 'March 12, 2026',
    readTime: '4 min read',
    image: 'https://readdy.ai/api/search-image?query=sneakers%20shoes%20footwear%20discount%20sale%20bright%20white%20background%20clean%20minimal%20modern%20fashion%20sport&width=800&height=500&seq=art016&orientation=landscape',
  },
  {
    id: 17,
    slug: 'joyagoo-hoodie-deals',
    title: 'Joyagoo Hoodie Deals – Best Prices on Hoodies & Sweaters',
    excerpt: 'Shop the best joyagoo hoodie deals and sweater discounts. Use our exclusive coupon codes to save on the most popular hoodie styles.',
    category: 'longtail',
    categoryLabel: 'Hoodie Deal',
    date: 'March 10, 2026',
    readTime: '4 min read',
    image: 'https://readdy.ai/api/search-image?query=hoodie%20sweater%20fashion%20clothing%20discount%20sale%20bright%20white%20background%20clean%20minimal%20modern%20casual&width=800&height=500&seq=art017&orientation=landscape',
  },
  {
    id: 18,
    slug: 'joyagoo-shipping-coupon',
    title: 'Joyagoo Shipping Coupon – Get Free or Discounted Shipping',
    excerpt: 'Save on delivery costs with joyagoo shipping coupons. Find free shipping codes, discounted shipping offers, and tips to minimize your shipping fees.',
    category: 'longtail',
    categoryLabel: 'Shipping Coupon',
    date: 'March 8, 2026',
    readTime: '4 min read',
    image: 'https://readdy.ai/api/search-image?query=free%20shipping%20delivery%20truck%20package%20discount%20bright%20white%20background%20clean%20minimal%20modern%20logistics&width=800&height=500&seq=art018&orientation=landscape',
  },
  {
    id: 19,
    slug: 'joyagoo-coupon-2026',
    title: 'Joyagoo Coupon 2026 – All Active Codes & Seasonal Deals',
    excerpt: 'Your complete guide to joyagoo coupons in 2026. We track all active codes, seasonal sales, and special promotions so you never miss a deal.',
    category: 'longtail',
    categoryLabel: '2026 Deals',
    date: 'March 5, 2026',
    readTime: '5 min read',
    image: 'https://readdy.ai/api/search-image?query=2026%20coupon%20deals%20sale%20fashion%20shopping%20bright%20white%20background%20clean%20minimal%20modern%20discount%20tag&width=800&height=500&seq=art019&orientation=landscape',
  },
  {
    id: 20,
    slug: 'joyagoo-free-shipping',
    title: 'Joyagoo Free Shipping – How to Qualify & Save on Every Order',
    excerpt: 'Learn exactly how to get joyagoo free shipping on every order. Discover minimum order thresholds, free shipping codes, and the best shipping methods.',
    category: 'longtail',
    categoryLabel: 'Free Shipping',
    date: 'March 2, 2026',
    readTime: '4 min read',
    image: 'https://readdy.ai/api/search-image?query=free%20shipping%20gift%20box%20delivery%20bright%20white%20background%20clean%20minimal%20modern%20package%20celebration&width=800&height=500&seq=art020&orientation=landscape',
  },
];

export const categories = [
  { name: 'Shoes', url: 'https://repsw2c.com/category-911-Shoes.html', icon: 'ri-footprint-line', image: 'https://readdy.ai/api/search-image?query=stylish%20sneakers%20shoes%20collection%20white%20clean%20background%20minimal%20fashion%20sport%20footwear%20display&width=400&height=300&seq=cat001&orientation=landscape' },
  { name: 'Hoodies/Sweaters', url: 'https://repsw2c.com/search-912/name/Shoes.html', icon: 'ri-shirt-line', image: 'https://readdy.ai/api/search-image?query=hoodie%20sweater%20collection%20white%20clean%20background%20minimal%20fashion%20casual%20clothing%20display&width=400&height=300&seq=cat002&orientation=landscape' },
  { name: 'T-Shirts', url: 'https://repsw2c.com/search-913/name/Shoes.html', icon: 'ri-t-shirt-line', image: 'https://readdy.ai/api/search-image?query=t-shirt%20collection%20white%20clean%20background%20minimal%20fashion%20casual%20clothing%20display%20folded&width=400&height=300&seq=cat003&orientation=landscape' },
  { name: 'Jackets', url: 'https://repsw2c.com/search-914/name/Shoes.html', icon: 'ri-windy-line', image: 'https://readdy.ai/api/search-image?query=jacket%20coat%20collection%20white%20clean%20background%20minimal%20fashion%20outerwear%20clothing%20display&width=400&height=300&seq=cat004&orientation=landscape' },
  { name: 'Pants/Shorts', url: 'https://repsw2c.com/search-915/name/Shoes.html', icon: 'ri-layout-bottom-line', image: 'https://readdy.ai/api/search-image?query=pants%20shorts%20collection%20white%20clean%20background%20minimal%20fashion%20casual%20clothing%20display&width=400&height=300&seq=cat005&orientation=landscape' },
  { name: 'Headwear', url: 'https://repsw2c.com/search-916/name/Shoes.html', icon: 'ri-user-line', image: 'https://readdy.ai/api/search-image?query=hat%20cap%20headwear%20collection%20white%20clean%20background%20minimal%20fashion%20accessories%20display&width=400&height=300&seq=cat006&orientation=landscape' },
  { name: 'Sets', url: 'https://repsw2c.com/search-917/name/Shoes.html', icon: 'ri-stack-line', image: 'https://readdy.ai/api/search-image?query=matching%20set%20outfit%20collection%20white%20clean%20background%20minimal%20fashion%20clothing%20display%20coordinated&width=400&height=300&seq=cat007&orientation=landscape' },
  { name: 'Underwear', url: 'https://repsw2c.com/search-918/name/Shoes.html', icon: 'ri-heart-line', image: 'https://readdy.ai/api/search-image?query=underwear%20basics%20collection%20white%20clean%20background%20minimal%20fashion%20clothing%20display%20comfortable&width=400&height=300&seq=cat008&orientation=landscape' },
  { name: 'Jersey', url: 'https://repsw2c.com/search-919/name/Shoes.html', icon: 'ri-trophy-line', image: 'https://readdy.ai/api/search-image?query=sports%20jersey%20collection%20white%20clean%20background%20minimal%20fashion%20athletic%20clothing%20display&width=400&height=300&seq=cat009&orientation=landscape' },
  { name: 'Accessories', url: 'https://repsw2c.com/search-920/name/Shoes.html', icon: 'ri-handbag-line', image: 'https://readdy.ai/api/search-image?query=accessories%20bags%20belts%20collection%20white%20clean%20background%20minimal%20fashion%20display%20stylish&width=400&height=300&seq=cat010&orientation=landscape' },
];
